import { DB_PERSISTED_MY_RUNS_CONFIG_KEY } from '@neptune/home-page-domain';

import { dbPersistedConfigStore } from 'common/db-persisted-config-store';

export type MyRunsStorageStorage = {
  getRegex(): string | undefined;
  setRegex(regex: string): Promise<void>;
};

export function createMyRunsStore(): MyRunsStorageStorage {
  function getRegex(): string | undefined {
    return dbPersistedConfigStore.getItem(DB_PERSISTED_MY_RUNS_CONFIG_KEY);
  }

  async function setRegex(regex: string) {
    const value = regex === '' ? undefined : regex;
    await dbPersistedConfigStore.setItem(DB_PERSISTED_MY_RUNS_CONFIG_KEY, value);
  }

  return {
    setRegex,
    getRegex,
  };
}

export const myRunsStore = createMyRunsStore();
